import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';
import Layout from '../components/Layout';
import { TileGrid, TilesHead } from '../components/Tiles';

// ─── Отчёты и справки: одна дверь вместо пяти пунктов меню ───────────────────
//
// В боковом меню висела группа «Учёт» — до пяти строк у одной роли: история
// смен, реестр выпуска, движение ТМЗ, журнал действий, обмен с 1С. Открывают их
// не каждый день, а место они занимали наравне с работой, ради которой человек
// вообще заходит в программу.
//
// Теперь это одна дверь. Внутри — плитки: видно, что здесь лежит, и понятно,
// зачем каждое, без того чтобы держать пять названий в голове.

// «Выпущенные листы» и «Смены по дням» отсюда убраны — они вернулись в меню.
//
// Их спрятали сюда по признаку «открывают не каждый день». Признак оказался
// неверным: по ним разбирают спор о цифре выпуска и ищут, откуда взялся плохой
// лист, и в цеху это делают постоянно. За общей дверью с безликим именем их
// перестали находить — на заводе решили, что окно с листами пропало вовсе.
const ALL = [
  { key: '/orders-by-day', icon: '▤', title: 'Заказы по дням',
    hint: 'Принятые заказы за период: по дням, ЛДСП, контрагентам, менеджерам — с выгрузкой в Excel',
    color: '#22c55e',
    roles: ['director', 'admin', 'buhgalter', 'technolog', 'sklad_gp', 'investor'] },
  { key: '/stock-movement', icon: '≡', title: 'Что пришло и ушло',
    hint: 'Приход, расход и остаток по складам — сверка с 1С',
    color: '#0ea5e9',
    roles: ['director', 'admin', 'sklad_gp', 'buhgalter', 'investor'] },
  { key: '/audit', icon: '☰', title: 'Кто что менял',
    hint: 'Журнал действий: кто, когда и что сделал в программе',
    color: '#64748b',
    roles: ['admin', 'director'] },
  { key: '/integration', icon: '⇆', title: 'Обмен с 1С',
    hint: 'Что ушло в 1С, что застряло и почему',
    color: '#f59e0b',
    roles: ['admin'] },
];

export default function ReportsPage() {
  const navigate = useNavigate();
  const role = sessionStorage.getItem('role');
  const tiles = ALL.filter(x => x.roles.includes(role));

  return (
    <Layout title={t('Отчёты и справки')}>
      <TilesHead
        title="Отчёты и справки"
        hint="Сюда заходят, когда нужно посмотреть или сверить — работа делается на главном экране" />
      <TileGrid tiles={tiles} onPick={(to) => navigate(to)} />
    </Layout>
  );
}
